@if (hidden() != true) {
    @if (hasNext() == false && skip() > 0 && itemCount() > 0 && showJumpToTop()) {
        <tr class="d-none d-sm-table-row">
            <td colspan="100%" class="text-center fw-semibold pt-4">
                No more results
                <div class="pt-3">
                    <button type="button" class="btn btn btn-ms-secondary" (click)="jumpTo(scrollToElementName())">Jump to top</button>
                </div>
            </td>
        </tr>

        <div class="d-block d-sm-none text-center">
            No more results
            <div class="pt-3">
                <button type="button" class="btn btn btn-ms-secondary" (click)="jumpTo(scrollToElementMobileName())">Jump to top</button>
            </div>
        </div>
    } @else if (hasNext() == false && itemCount() == 0) {
        <tr class="d-none d-sm-table-row">
            <td colspan="100%" class="text-center fw-semibold pt-4">
                No results found
            </td>
        </tr>

        <div class="d-block d-sm-none text-center">
            No results found
        </div>
    }
    @else {
        <tr class="d-none d-sm-table-row">
            <td colspan="100%" class="text-center fw-semibold pt-4">
                <div ms-in-view-port (inViewPort)="inViewPort()"></div>
            </td>
        </tr>

        <div class="d-block d-sm-none" ms-in-view-port (inViewPort)="inViewPort()"></div>
    }
}